import { TextField, type TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';
import { LabeledField } from '../LabeledField';

/**
 * @tier molecule
 *
 * Single-line text input with a stacked label (label sits above the
 * field, not floating into the outline notch). Pass `label`,
 * `placeholder`, `helperText`, `error`, `disabled`, `fullWidth`,
 * adornments, `type`, and `inputMode`. For multi-line input use
 * `VyTextarea`.
 */
export type VyTextFieldProps = Omit<TextFieldProps, 'multiline' | 'minRows' | 'maxRows' | 'label' | 'helperText'> & {
  /** Field label rendered above the input. */
  label?: string;
  /** Hint shown below the input. Becomes the error message when `error` is true. */
  helperText?: string;
};

export const VyTextField = forwardRef<HTMLDivElement, VyTextFieldProps>(
  function VyTextField({ label, helperText, error, fullWidth = true, ...rest }, ref) {
    return (
      <LabeledField label={label} helperText={helperText} error={error}>
        <TextField ref={ref} variant="outlined" size="small" fullWidth={fullWidth} error={error} {...rest} />
      </LabeledField>
    );
  },
);
